import React from 'react';
import { Alert } from 'antd';
import styled from 'styled-components';

const AlertBanner = styled(Alert)`
  margin: 0;
  border: none;
  border-radius: 0;
  text-align: left;
  padding-left: 32px;
  
  .ant-alert-message {
    text-align: left;
  }
`;

interface BetaBannerProps {
  visible: boolean;
  onClose: () => void;
}

const BetaBanner: React.FC<BetaBannerProps> = ({ visible, onClose }) => {
  if (!visible) return null;

  return (
    <AlertBanner
      message="本平台目前处于内测阶段，暂未开通支付功能。如有任何问题或建议，请发送邮件至 minimoney@aliyun.com"
      type="warning"
      closable
      onClose={onClose}
      banner
    />
  );
};

export default BetaBanner; 